import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`fixed w-full top-0 left-0 z-50 transition-all duration-300 ${
      scrolled ? 'h-16 bg-white/95 backdrop-blur shadow-md' : 'h-20 bg-white shadow-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        <div className="flex items-center">
          <a href="/" className="flex items-center text-primary">
            <span className="font-playfair text-xl md:text-2xl font-bold mr-2 transition-all">
              AEK Kafe
            </span>
            <span className="text-xl animate-steam">☕</span>
          </a>
        </div>
        
        <div className="block lg:hidden">
          <button 
            onClick={toggleMenu}
            className="flex flex-col justify-between w-7 h-6 focus:outline-none"
            aria-label="Menu"
          >
            <span className={`w-full h-0.5 bg-primary rounded-full transition-all duration-300 ${
              isOpen ? 'transform rotate-45 translate-y-2.5' : ''
            }`}></span>
            <span className={`w-full h-0.5 bg-primary rounded-full transition-all duration-300 ${
              isOpen ? 'opacity-0' : ''
            }`}></span>
            <span className={`w-full h-0.5 bg-primary rounded-full transition-all duration-300 ${
              isOpen ? 'transform -rotate-45 -translate-y-2.5' : ''
            }`}></span>
          </button>
        </div>
        
        <div className={`fixed top-0 right-0 h-screen w-[70%] lg:w-auto lg:h-auto lg:static lg:flex bg-light lg:bg-transparent transform transition-transform duration-300 ease-in-out lg:translate-x-0 pt-24 lg:pt-0 shadow-lg lg:shadow-none ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}>
          <ul className="flex flex-col lg:flex-row items-center lg:items-stretch space-y-6 lg:space-y-0 lg:space-x-6">
            <li className="text-center w-full lg:w-auto">
              <a href="/" className="text-dark text-lg lg:text-base font-medium hover:text-secondary px-4 py-3 lg:py-2 block lg:inline relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-secondary after:transition-all">
                Ana Sayfa
              </a>
            </li>
            <li className="text-center w-full lg:w-auto">
              <a href="/menu" className="text-dark text-lg lg:text-base font-medium hover:text-secondary px-4 py-3 lg:py-2 block lg:inline relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-secondary after:transition-all">
                Menü
              </a>
            </li>
            <li className="text-center w-full lg:w-auto">
              <a href="/hakkimizda" className="text-dark text-lg lg:text-base font-medium hover:text-secondary px-4 py-3 lg:py-2 block lg:inline relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-secondary after:transition-all">
                Hakkımızda
              </a>
            </li>
            <li className="text-center w-full lg:w-auto">
              <a href="/galeri" className="text-dark text-lg lg:text-base font-medium hover:text-secondary px-4 py-3 lg:py-2 block lg:inline relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-secondary after:transition-all">
                Galeri
              </a>
            </li>
            <li className="text-center w-full lg:w-auto">
              <a href="/iletisim" className="text-dark text-lg lg:text-base font-medium hover:text-secondary px-4 py-3 lg:py-2 block lg:inline relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-secondary after:transition-all">
                İletişim
              </a>
            </li>
            <li className="text-center w-full lg:w-auto mt-4 lg:mt-0">
              <a href="/rezervasyon" className="bg-secondary hover:bg-primary text-white rounded-full px-6 py-2 inline-block transition-all hover:shadow-md hover:-translate-y-0.5">
                Rezervasyon
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
